import { images } from '../constants';

export const news = [
    {
        id: 1,
        title: 'news.item1.title',
        content: 'news.item1.content',
        source: 'TuKutno.pl',
        link: 'https://tukutno.pl/pl/11_wiadomosci/15861_70-milionow-na-kwiatowy-raj-odnowa-dworu-12-ha-parku-i-ogrod-botaniczny-foto.html'
    },
    {
        id: 2,
        title: 'news.item2.title',
        content: 'news.item2.content',
        source: 'Panorama Kutna',
        link: 'https://panoramakutna.pl/pod-kutnem-powstanie-najwiekszy-ogrod-rozany-w-polsce/'
    },
    {
        id: 3,
        title: 'news.item3.title',
        content: 'news.item3.content',
        source: 'Kutno.net.pl',
        link: 'https://kutno.net.pl/wydarzenia/maja-ambitne-plany-w-woj-lodzkim-powstanie-najwiekszy-taki-obiekt-w-polsce/44DwSFup7zR4aqKXmrBT'
    },
    {
        id: 4,
        title: 'news.item4.title',
        content: 'news.item4.content',
        source: 'TuLodz.pl',
        link: 'https://tulodz.pl/lodzkie/nowa-atrakcja-turystyczna-w-lodzkiem-to-ma-byc-najwiekszy-taki-obiekt-w-polsce/SPxAZKFBtJTDeA5kCDPF'
    },
    {
        id: 5,
        title: 'news.item5.title',
        content: 'news.item5.content',
        source: 'Życie Kutna',
        link: 'https://zyciekutna.com.pl/tag/fundacja-dwor-imielno/'
    },
    {
        id: 6,
        title: 'news.item6.title',
        content: 'news.item6.content',
        source: 'PTRosa.pl',
        link: 'https://ptrosa.pl/2025/12/10/dwor-imielno-wraz-z-parkiem-nowy-projekt-w-realizacji/'
    },
    {
        id: 7,
        title: 'news.item7.title',
        content: 'news.item7.content',
        source: 'Życie Kutna',
        link: 'https://zyciekutna.com.pl/2025/11/28/gmina-nowe-ostrowy-wesprze-powstanie-ogrodu-botanicznego-w-imielnie-podpisano-list-intencyjny/'
    },
    {
        id: 8,
        image: images.partner8,
        title: 'news.item8.title',
        content: 'news.item8.content',
        source: 'BiznesOgrodniczy',
        link: 'https://biznes-ogrodniczy.pl/magazyn/biznes-ogrodniczy-luty-2026/?fbclid=IwY2xjawQk1PVleHRuA2FlbQIxMABicmlkETBLRWtseVE0QWVSVElhS05Wc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHo6XL3gSq1Ushu3HbYYDB3ADG0dzC9HhnYVCanfOnvcGyBqjKbdYWDIp3dx-_aem_2-6I2XcoU-ULi_toTEf87A#flipbook-df_31078/40/'
    },
    {
        id: 9,
        title: 'news.item9.title',
        content: 'news.item9.content',
        source: 'panoramakutna.pl',
        link: 'https://panoramakutna.pl/w-regionie-moze-powstac-ogrod-rozany-kolejny-krok-w-kierunku-realizacji-projektu-zdjecia/?fbclid=IwY2xjawRdtlVleHRuA2FlbQIxMQBicmlkETBLRWtseVE0QWVSVElhS05Wc3J0YwZhcHBfaWQBMAABHufoGpA9KVqj1Jnyf4fx9XGbW5_W2Ql8YI-FthIs4VZp4jmibzOIRm3eAl5m_aem_-_2_sbAW5f9B7tHIuMT2pw'
    },
    {
        id: 10,
        title: 'news.item10.title',
        content: 'news.item10.content',
        source: 'ekutno.pl',
        link: 'https://ekutno.pl/pl/14_kultura/75282_fundacja-dwor-imielno-stworzy-rosarium-ogrod-rozany-w-kutnie.html'
    },
    {
        id: 11,
        title: 'news.item11.title',
        content: 'news.item11.content',
        source: 'tukutno.pl',
        link: 'https://tukutno.pl/pl/11_wiadomosci/19119_rosarium-i-nowe-wydarzenia-efekty-wspolpracy-kdk-i-dworu-imielno.html'
    },
];

export default news;